import { render, staticRenderFns } from "./viewRole.vue?vue&type=template&id=7a5e94b8&"
import script from "./viewRole.vue?vue&type=script&lang=js&"
export * from "./viewRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports